export default __webpack_public_path__ + "static/media/1888.2463e9eb.png";